import { useLingui } from '@lingui/react';
import { useDoubleOptInConfig, useGetConsumerCarlead, useTrackCustomerBanner } from '@wkda/funnel-components';
import { Button } from '@wkda/styleguide';
import cx from 'classnames';
import get from 'lodash-es/get';
import { useCallback, useEffect } from 'react';
import { useCarleadConfiguration } from '../../../hooks/useCarleadCreationConfiguration';
import { useCarleadDataLayer } from '../../../hooks/useCarleadDataLayer';
import { BenefitsList } from './BenefitsList';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function L2ASelfEvaluationDoi(_ref) {
  let {
    marketingExperiment,
    offerPrice,
    manufacturer,
    model,
    emailCreatedOn,
    carleadHash
  } = _ref;
  const {
    i18n: _i18n
  } = useLingui();
  const dataLayer = useCarleadDataLayer();
  const {
    data: consumer
  } = useGetConsumerCarlead(carleadHash);
  const {
    doiDomains,
    fullLocale
  } = useCarleadConfiguration();
  const {
    data: doubleOptInConfig,
    isLoading: doubleOptInConfigLoading
  } = useDoubleOptInConfig(carleadHash !== null && carleadHash !== void 0 ? carleadHash : '');
  const {
    trackShownEvent,
    trackCTAClickEvent,
    getCJTrackingButtonNameByAttr
  } = useTrackCustomerBanner();
  const provider = get(doubleOptInConfig, ['wkda', 'category'], 'DEFAULT');
  const doi = get(doiDomains, [fullLocale, provider], null);
  const noPriceMarketingProperty = marketingExperiment === null || marketingExperiment === void 0 ? void 0 : marketingExperiment.selfEvaHideOnlinePrice;
  const benefitsTranslations = ['carleadCreation.l2aSelfEvaluationRCB.benefitsList.first', 'carleadCreation.l2aSelfEvaluationRCB.benefitsList.second', 'carleadCreation.l2aSelfEvaluationRCB.benefitsList.third'];
  const handleButtonClick = useCallback(e => {
    const ctaName = getCJTrackingButtonNameByAttr(e.currentTarget);
    if (ctaName) {
      trackCTAClickEvent('lead-to-appointment-doi', ctaName);
    }
  }, [getCJTrackingButtonNameByAttr, trackCTAClickEvent]);
  useEffect(() => {
    if (!doubleOptInConfigLoading) {
      dataLayer.pushCustomerBannerOpen('lead-to-appointment-doi');
      trackShownEvent('lead-to-appointment-doi');
    }
  }, [dataLayer, doubleOptInConfigLoading, trackShownEvent]);
  function getDOIUrl() {
    if (doi !== null && doi !== void 0 && doi.filterUrlFn && consumer) {
      return doi.filterUrlFn(consumer);
    }
    return doi === null || doi === void 0 ? void 0 : doi.url;
  }
  if (doubleOptInConfigLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: "container l2a-self-evaluation-rcb",
    children: /*#__PURE__*/_jsxs("div", {
      className: "row justify-content-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: cx('col-md-4', {
          'd-none': noPriceMarketingProperty
        }),
        children: /*#__PURE__*/_jsxs("div", {
          className: "d-none d-md-block",
          children: [/*#__PURE__*/_jsx("div", {
            className: "l2a-self-evaluation-rcb__title",
            children: offerPrice ? _i18n._('carleadCreation.l2aSelfEvaluationRCB.priceTitle', {
              manufacturer,
              model
            }) : _i18n._('carleadCreation.l2aSelfEvaluationRCB.noPriceTitle')
          }), /*#__PURE__*/_jsx("div", {
            className: "banner-return-customer__pixelated-price banner-return-customer__price l2a-self-evaluation-rcb__pixelated-price"
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "col-md-4 text-center",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "l2a-self-evaluation-rcb__title font-weight-bold",
          children: [/*#__PURE__*/_jsx("span", {
            className: "d-lg-none",
            children: _i18n._('carleadCreation.l2aSelfEvaluationRCB.doiTitleShort')
          }), /*#__PURE__*/_jsx("span", {
            className: "d-none d-lg-block",
            children: _i18n._('carleadCreation.l2aSelfEvaluationRCB.doiTitleFull')
          })]
        }), /*#__PURE__*/_jsx("p", {
          className: "l2a-self-evaluation-rcb__text-box",
          children: _i18n._('carleadCreation.l2aSelfEvaluationRCB.notificationTitle', {
            emailCreatedOn
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: cx('col-sm-4 l2a-self-evaluation-rcb__col-3', {
          'text-center ': !!doi
        }),
        children: [doi && /*#__PURE__*/_jsx("div", {
          className: "l2a-self-evaluation-rcb__provider-link l2a-self-evaluation-rcb__provider-link--" + provider,
          children: /*#__PURE__*/_jsxs(Button, {
            "data-cj-tracking-button-name": "doi-redirect-button",
            component: "a",
            variant: "primary",
            target: "_blank",
            className: "l2a-self-evaluation-rcb__button l2a-self-evaluation-rcb__button--" + provider,
            rel: "noopener noreferrer",
            href: getDOIUrl(),
            onClick: handleButtonClick,
            children: [_i18n._('carleadCreation.l2aSelfEvaluationRCB.directTo'), ' ', doi === null || doi === void 0 ? void 0 : doi.domain]
          })
        }), !doi && /*#__PURE__*/_jsx(BenefitsList, {
          className: "d-none d-md-block",
          classNameRowText: "l2a-self-evaluation-rcb__list-item-text",
          benefitsTranslations: benefitsTranslations
        })]
      })]
    })
  });
}